import propTypes from "prop-types";

const BannerImage = ({
  altText,
  largeImage,
  mediumImage,
  smallImage,
  imageRef
}) => {
  return (
    <picture>
      <source
        data-testid="large-image"
        media="(min-width: 1024px)"
        srcSet={largeImage}
      />
      <source
        data-testid="medium-image"
        media="(min-width: 768px)"
        srcSet={mediumImage}
      />
      <source data-testid="small-image" srcSet={smallImage} />
      <img alt={altText} ref={imageRef} />
    </picture>
  );
};

BannerImage.propTypes = {
  altText: propTypes.string,
  largeImage: propTypes.string,
  mediumImage: propTypes.string,
  smallImage: propTypes.string,
  imageRef: propTypes.object
};

export default BannerImage;
